import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEventsRsvpRsvpManagementUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/events/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/events-rsvp-management-v1-proxy',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    _: [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/rsvp',
        destPath: '/v1/rsvp',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_events_rsvp';

/**
 * Retrieves a list of up to 100 RSVPs.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.QueryRsvps(), and will be removed on 2025-06-30.
 */
export function listRsvp(payload: object): RequestOptionsFactory<any> {
  function __listRsvp({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'GET' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.ListRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvps.created' },
              { path: 'rsvps.modified' },
              { path: 'rsvps.rsvpForm.inputValues.dateTime' },
              { path: 'rsvps.guests.checkIn.created' },
              { path: 'rsvps.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvps.rsvpForm.inputValues.number' },
              {
                path: 'rsvps.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvps.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listRsvp;
}

/**
 * Retrieves a list of up to 100 RSVPs.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.QueryRsvps(), and will be removed on 2025-06-30.
 */
export function queryRsvp(payload: object): RequestOptionsFactory<any> {
  function __queryRsvp({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'POST' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.QueryRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvps.created' },
              { path: 'rsvps.modified' },
              { path: 'rsvps.rsvpForm.inputValues.dateTime' },
              { path: 'rsvps.guests.checkIn.created' },
              { path: 'rsvps.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvps.rsvpForm.inputValues.number' },
              {
                path: 'rsvps.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvps.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryRsvp;
}

/**
 * Retrieves an RSVP.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.GetRsvp(), and will be removed on 2025-06-30.
 */
export function getRsvp(payload: object): RequestOptionsFactory<any> {
  function __getRsvp({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'GET' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.GetRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp/{rsvpId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvp.created' },
              { path: 'rsvp.modified' },
              { path: 'rsvp.rsvpForm.inputValues.dateTime' },
              { path: 'rsvp.guests.checkIn.created' },
              { path: 'rsvp.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvp.rsvpForm.inputValues.number' },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getRsvp;
}

/**
 * Creates an RSVP, associated with a contact of the site.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.CreateRsvp(), and will be removed on 2025-06-30.
 */
export function createRsvp(payload: object): RequestOptionsFactory<any> {
  function __createRsvp({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'form.inputValues.number' },
          { path: 'form.inputValues.address.address.geocode.latitude' },
          { path: 'form.inputValues.address.address.geocode.longitude' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'form.inputValues.dateTime' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'POST' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.CreateRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvp.created' },
              { path: 'rsvp.modified' },
              { path: 'rsvp.rsvpForm.inputValues.dateTime' },
              { path: 'rsvp.guests.checkIn.created' },
              { path: 'rsvp.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvp.rsvpForm.inputValues.number' },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createRsvp;
}

/**
 * Updates an RSVP.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.UpdateRsvp(), and will be removed on 2025-06-30.
 */
export function updateRsvp(payload: object): RequestOptionsFactory<any> {
  function __updateRsvp({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'rsvpForm.inputValues.number' },
          { path: 'rsvpForm.inputValues.address.address.geocode.latitude' },
          { path: 'rsvpForm.inputValues.address.address.geocode.longitude' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'rsvpForm.inputValues.dateTime' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.UpdateRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp/{rsvpId}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvp.created' },
              { path: 'rsvp.modified' },
              { path: 'rsvp.rsvpForm.inputValues.dateTime' },
              { path: 'rsvp.guests.checkIn.created' },
              { path: 'rsvp.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvp.rsvpForm.inputValues.number' },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateRsvp;
}

/**
 * Updates statuses of multiple RSVPs.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.BulkUpdateRsvps(), and will be removed on 2025-06-30.
 */
export function bulkUpdateRsvp(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateRsvp({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.BulkUpdateRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvps.created' },
              { path: 'rsvps.modified' },
              { path: 'rsvps.rsvpForm.inputValues.dateTime' },
              { path: 'rsvps.guests.checkIn.created' },
              { path: 'rsvps.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvps.rsvpForm.inputValues.number' },
              {
                path: 'rsvps.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvps.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateRsvp;
}

/**
 * Deletes an RSVP.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.DeleteRsvp(), and will be removed on 2025-06-30.
 */
export function deleteRsvp(payload: object): RequestOptionsFactory<any> {
  function __deleteRsvp({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.DeleteRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteRsvp;
}

/**
 * Checks-in an RSVP.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.CheckInRsvpGuests(), and will be removed on 2025-06-30.
 */
export function checkInRsvp(payload: object): RequestOptionsFactory<any> {
  function __checkInRsvp({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'POST' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.CheckInRsvp',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp/check-in',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvp.created' },
              { path: 'rsvp.modified' },
              { path: 'rsvp.rsvpForm.inputValues.dateTime' },
              { path: 'rsvp.guests.checkIn.created' },
              { path: 'rsvp.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvp.rsvpForm.inputValues.number' },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __checkInRsvp;
}

/**
 * Deletes an RSVP check-in.
 * @deprecated It has been replaced with wix.events.rsvps.v2.RsvpManagement.CancelRsvpGuestsCheckIn(), and will be removed on 2025-06-30.
 */
export function deleteRsvpCheckIn(payload: object): RequestOptionsFactory<any> {
  function __deleteRsvpCheckIn({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.rsvp',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.rsvp.RsvpManagement.DeleteRsvpCheckIn',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsRsvpRsvpManagementUrl({
        protoPath: '/v1/rsvp/check-in',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'rsvp.created' },
              { path: 'rsvp.modified' },
              { path: 'rsvp.rsvpForm.inputValues.dateTime' },
              { path: 'rsvp.guests.checkIn.created' },
              { path: 'rsvp.guests.checkIn.checkInCanceledDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'rsvp.rsvpForm.inputValues.number' },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'rsvp.rsvpForm.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __deleteRsvpCheckIn;
}
